module.exports = __webpack_public_path__ + "img/logo-sd.ac245bdc.png";